export const PasswordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}/;
export const EmailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
